









































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import Article from "@/store/entities/article";
import url from "@/lib/url";
import Ajax from "@/lib/ajax";
//import ewebeditor from "@/components/ewebeditor.vue";

@Component({
  components: {},
})
export default class EditArticle extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  article: Article = new Article();

  editorContentConfig: any = {
    style: "gray",
    width: "100%",
    height: "500px",
  };
  frontendurl: string = "https://manage.sxjy.cq.cn/dist/ewebeditor/";
  editorBackendurl: string = "https://manage.sxjy.cq.cn/dist/ewebeditor/";
  formTitle: string = "文章发布";
  isCreate: boolean = true;
  data: any = [];
  valueArray: any = [];
  parentId?: number;
  categoryId?: number;
  parentName: string = "一级分类";
  topicData: any = [];
  topicOne: any = [];
  topicTwo: any = [];
  uploadActin: string = url + "api/services/app/File/FileGetToken";
  token: string = "Bearer " + window.abp.auth.getToken();
  uploadList: any = [];
  uploadPdfList: any = [];
  content: string = "";
  titePictureImg: string = "";
  screenWidth: number = document.body.clientWidth - 200;
  mobilescreenWidth: string = "100%";
  // handleBeforeUpload() {
  //   const check = this.uploadList.length < 1
  //   return check
  // }
  handleBeforeUpload(file) {
    this.titePictureImg = "";
    this.uploadList = new Array();
    (this.$refs.upload as any).clearFiles();
    let reader = new FileReader();
    reader.readAsDataURL(file);
    let _this = this;
    reader.onloadend = function(e) {
      _this.titePictureImg = reader.result.toString(); //  console.log(reader.result) // file.url = reader.result // _this.uploadList.push(file)
    };
    const check = this.uploadList.length < 1;
    return check;
  }

  contentFormSelect(name) {
    this.article.contentForm = name;
  }
  uploadSuccess(res, file, fileList) {
    this.uploadList = fileList;
  }
  handleRemove(file, fileList) {
    this.titePictureImg = "";
    this.uploadList = fileList;
  }
  handleMaxSize(file) {
    this.$Notice.warning({
      title: "超出文件大小限制",
      desc: "文件【" + file.name + "】 太大, 不能超过2M.",
    });
  }

  cascaderSelect(value, selectedData) {
    if (selectedData.length > 0) {
      this.article.allCategorys = value.join(",");

      this.categoryId = selectedData[0].id;
    } else {
      this.article.allCategorys = null;
    }
  }
  topicOneSelect(value, selectedData) {
    if (selectedData.length > 0)
      this.article.topicOneId = selectedData[selectedData.length - 1].value;
    else this.article.topicOneId = null;
  }
  topicTwoSelect(value, selectedData) {
    if (selectedData.length > 0)
      this.article.topicTwoId = selectedData[selectedData.length - 1].value;
    else this.article.topicTwoId = null;
  }
  save() {
    (this.$refs.articleForm as any).validate(async (valid: boolean) => {
      if (valid) {
        if (!this.valueArray.length) {
          this.$Message.warning("请选择文章分类");
          return false;
        }
        if (!this.article.title) {
          this.$Message.warning("请填写文章标题");
          return false;
        }
        //  if (!this.article.issued) {
        //    this.$Message.warning("请填写文章来源");
        //   return false;
        // }
        /**
        if (!this.article.author) {
          this.$Message.warning("请填写文章作者");
          return false;
        }
        **/

        if (this.uploadList && this.uploadList.length > 0)
          this.article.titlePicture = this.uploadList[0].response.result;
        let sendType = "article/update";
        let yxurl =
          "https://yxpt.sxjy.cq.cn/yxpt/index.php?s=/api/article/addyx";
        // this.article.content = (this.$refs["ewe"] as any).getHtmleweb();
        if (!this.article.content) {
          this.$Message.warning("请填写文章内容");
          return false;
        }
        if (this.isCreate) {
          sendType = "article/create";
        }
        await this.$store.dispatch({
          type: sendType,
          data: this.article,
        });

        if (this.categoryId == 3 && this.isCreate) {
          let form = {
            categoryId: this.categoryId,
            content: this.article.content,
            source: this.article.issued,
            author: this.article.author,
            title: this.article.title,
          };
          Ajax.post(yxurl, { form: form });
        }
        // ;(this.$refs.articleForm as any).resetFields()
        // this.$emit('save-success')
        // this.$emit('input', false)
        if (this.isCreate) {
          //   (this.$refs["ewe"] as any).setHtmleweb("");
          this.article.content = "";
          this.topicOne = [];
          this.topicTwo = [];
          this.article.title = "";
          this.article.description = "";
          this.article.isRollingShow = false;
          this.article.isRecommend = false;
          this.titePictureImg = "";
          this.article.titlePicture = "";
          this.uploadList = [];
          (this.$refs.upload as any).clearFiles();
        } else {
          (this.$refs.articleForm as any).resetFields();
          this.$emit("save-success");
          this.$emit("input", false);
        }
      }
    });
  }

  cancel() {
    this.visibleChange(false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.article = new Article();
      this.$store.state.article.editArticle = this.article;
      (this.$refs.articleForm as any).resetFields();
      if (this.isCreate) this.$emit("save-success");
      this.$emit("input", value);
    } else {
      this.data = this.$store.state.article.cascaders.items;
      this.topicData = this.$store.state.article.topicCascaders.items;
      this.article = Util.extend(
        true,
        {},
        this.$store.state.article.editArticle,
      );
      if (this.article.id) {
        this.$store
          .dispatch({
            type: "article/get",
            id: this.article.id,
          })
          .then((res) => {
            this.article.content = res.content;
            this.article.author = res.author;
            this.article.issued = res.issued;
            this.article.externalType = res.externalType;
            this.article.gradeType = res.gradeType;
            this.article.isRollingShow = res.isRollingShow;
            this.article.sortNo = res.sortNo;
            this.article.isRecommend = res.isRecommend;
            this.article.description = res.description;
            this.article.isAudit = res.isAudit;
          });

        this.isCreate = false;
        this.formTitle = "文章修改";
        this.titePictureImg = this.$store.state.article.editArticle.titlePicturePath;

        const categoryList = this.$store.state.article.editArticle.categoryList;
        this.article.allCategorys =
          categoryList.length > 0 ? categoryList.join(",") : "";

        // this.content = this.$store.state.article.editArticle.content;
        this.valueArray = this.$store.state.article.editArticle.categoryList;
        this.topicOne = this.$store.state.article.editArticle.topicOneList;
        this.topicTwo = this.$store.state.article.editArticle.topicTwoList;
        // this.setEditorData();
      } else {
        this.titePictureImg = "";
        this.isCreate = true;
        this.formTitle = "文章发布";
        this.valueArray = [];
        this.uploadList = [];

        //  (this.$refs["ewe"] as any).setHtmleweb("");
      }
    }
  }

  validateNameList = (rule, value, callback) => {
    if (value.length === 0) {
      callback(new Error("请选择name"));
    } else {
      callback();
    }
  };
}
